import { connect } from 'react-redux';

import ApprovedStatusActions from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ApprovedStatusActions);
